import { render, staticRenderFns } from "./GautasPranesimas.vue?vue&type=template&id=0c6bcff9&"
import script from "./GautasPranesimas.vue?vue&type=script&lang=js&"
export * from "./GautasPranesimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports